import { newStorage } from './storage';

const manageInstanceTable = newStorage('TABLE_MANAGE_INSTANCE');

export default manageInstanceTable;
